import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _7mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"7mp"}/>
}
